export { CDNImage, type CDNImageProps } from './CDNImage';
